import React, { useState } from 'react';
import { useHistory } from 'react-router';
import Logo from '../logo/Logo';

const HomeButton = () => {
  const history = useHistory();
  const [inlineCollapsed, setInlineCollapsed] = useState<boolean>(true);

  return (
    <div style={{ position: 'absolute', left: 0, top: 10 }}>
      <div
        className='home-button'
        style={{
          // padding: '8px 16px',
          cursor: 'pointer',
          display: 'inline-block',
          borderTopRightRadius: 30,
          borderBottomRightRadius: 30,
          paddingTop: 6,
          paddingBottom: 6,
          paddingLeft: 16,
        }}
        onClick={() => history.push('/')}>
        <Logo style={{ marginRight: '0.5em', height: '4em', marginBottom: 0 }} />
      </div>
    </div>
  );
};

export default HomeButton;
